import { useSelector } from "react-redux";
import { ApplicationState } from "@/store";

export const useBalanceState = () => {
  const selectBalanceState = (state: ApplicationState) => state.balance;
  
  return useSelector(selectBalanceState);
};